import { getAuthToken } from '../firebase/firebase';

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Get the current user's token balance
 * @returns {Promise<number>} The user's token balance
 */
export const getTokenBalance = async () => {
  try {
    const token = await getAuthToken();
    if (!token) {
      throw new Error('User not authenticated');
    }
    
    const endpoint = `${API_BASE_URL}/tokens/balance`;
    
    const response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch token balance');
    }
    
    const data = await response.json();
    return data.data.balance;
  } catch (error) {
    console.error('TokenService: Error fetching token balance:', error);
    throw error;
  }
};

/**
 * Get the user's token transaction history
 * @param {Object} options - Pagination options
 * @returns {Promise<Object>} The transaction history and total count
 */
export const getTokenTransactions = async (options = {}) => {
  try {
    const token = await getAuthToken();
    if (!token) {
      throw new Error('User not authenticated');
    }
    
    const { limit = 10, offset = 0 } = options;
    
    const response = await fetch(`${API_BASE_URL}/tokens/transactions?limit=${limit}&offset=${offset}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch token transactions');
    }
    
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error fetching token transactions:', error);
    throw error;
  }
}; 